import * as actionTypes from '../actions/actionTypes'

const initialState = {
  error : false,
  errorMessage : '',
  isRequestSentEmailResetPasswordSuccess : false,
  isFinishedChangePasswordSuccess: false,
}

const passwordReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_FAILED:
      return {
        ...state,
        error: true,
        errorMessage: action.errorMessage
      }
    case actionTypes.CLOSE_MODAL_ERROR:
      return {
        ...state,
        error: false
      }
    case actionTypes.REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isRequestSentEmailResetPasswordSuccess : true
      }
    case actionTypes.CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL:
      return {
        ...state,
        isRequestSentEmailResetPasswordSuccess : false
      }
    case actionTypes.REQUEST_SUCCESS_LOGIN:
      return {
        ...state,
        isFinishedChangePasswordSuccess: true
      }
    default:
      return state
  }
}


export default passwordReducer



// WEBPACK FOOTER //
// ./src/store/reducers/passwordReducer.js